import { render, staticRenderFns } from "./Dpick.vue?vue&type=template&id=cad63cd4&"
import script from "./Dpick.vue?vue&type=script&setup=true&lang=js&"
export * from "./Dpick.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Dpick.vue?vue&type=style&index=0&id=cad63cd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports